import type { InstantSurvey } from '@api/instant_survey/types';

export const isCalypsoSurvey = (survey?: InstantSurvey | null): boolean => {
  const surveyProvider = survey?.surveySource ?? survey?.surveySourceOverride ?? null;

  return surveyProvider?.toLowerCase() === 'calypso';
};
